// extracted by mini-css-extract-plugin
module.exports = {"button":"OrdersGroupPrintButton_button__IdqOE","button-ltr":"OrdersGroupPrintButton_button-ltr__3KgIl"};